import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const CaretUpFill = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='CaretUpFill' {...props}>
    <path d='M6 15H18L12 9L6 15Z' fill='#000' />
  </StyledIcon>
);
